var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.65,
    fill: "white",
    stroke: "#30854F",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1852 13.5852C11.315 13.7809 11.5097 13.8462 11.7693 13.8462C11.9965 13.8462 12.1912 13.7809 12.3535 13.5852L21.9268 3.99439C22.0566 3.8639 22.154 3.66817 22.154 3.4072C22.154 3.17884 22.0566 2.98311 21.9268 2.82L20.7261 1.64562C20.5638 1.48251 20.3691 1.38464 20.1419 1.38464C19.9148 1.38464 19.7201 1.48251 19.5578 1.64562L11.7693 9.47486L8.13473 5.82121C7.94002 5.6581 7.74531 5.56024 7.51814 5.56024C7.29098 5.56024 7.09627 5.6581 6.96646 5.82121L5.76574 6.9956C5.60348 7.15871 5.53857 7.35444 5.53857 7.58279C5.53857 7.84377 5.60348 8.0395 5.76574 8.16998L11.1852 13.5852Z",
    fill: "#30854F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMatch);
export default __webpack_public_path__ + "static/media/icon_match.5d72b4d168fae56a1faf8094eb73c41c.svg";
export { ForwardRef as ReactComponent };